import { TrackingDetails } from './components/TrackingDetails';
import { ShipmentDetails } from './components/ShipmentDetails';
import { ShipmentLayout } from '../ShipmentLayout';

interface SkeletonShipmentProps {
  isLoading: boolean;
  isNoShipment: boolean;
}

export const Skeleton = ({
  isLoading,
  isNoShipment,
}: SkeletonShipmentProps): JSX.Element => {
  const parcelDetails = (
    <ShipmentDetails isLoading={isLoading} isNoShipment={isNoShipment} />
  );

  const trackingDetails = (
    <TrackingDetails isLoading={isLoading} isNoShipment={isNoShipment} />
  );

  return (
    <ShipmentLayout
      parcelDetails={parcelDetails}
      trackingDetails={trackingDetails}
    />
  );
};
